"use strict";
var appn;
(function (appn) {
    var folderFilter;
    (function (folderFilter) {
        folderFilter.selectedFolderId = appn.emptyString;
        folderFilter.selectedItems = null;
        function init(reloadUrl, onAfterFolderChanged) {
            const folderIdFromUrl = appn.utils.getUrlParamByName('folderId');
            let value = getStateOrDefault().value;
            if (folderIdFromUrl)
                value = folderIdFromUrl;
            setValue(value);
            $('.appnFolderFilter .appnFolderFilter-link').off().on('click', function (e) {
                e.preventDefault();
                setValue($(this).prop('id'));
            });
            $(document).on('hidden.bs.modal', function () {
                if (!appn.iframe.getHost().reloadFlag)
                    return;
                appn.location.navTo(reloadUrl);
            });
        }
        folderFilter.init = init;
        function getStateOrDefault() {
            const appnFolderFilter = $('.appnFolderFilter');
            return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnFolderFilter), getValue());
        }
        folderFilter.getStateOrDefault = getStateOrDefault;
        function getValue() {
            const appnFolderFilter = $('.appnFolderFilter');
            const value = appnFolderFilter.find('li.active .appnFolderFilter-link').prop('id');
            if (value === 'appnFolderFilter-all')
                return appn.emptyString;
            return value;
        }
        folderFilter.getValue = getValue;
        function setValue(value) {
            appn.dataTable.uncheckAllRowsBox();
            folderFilter.selectedFolderId = !value || value === 'appnFolderFilter-all' ? appn.emptyString : value;
            if (getValue() === value)
                return;
            const appnFolderFilter = $('.appnFolderFilter');
            appnFolderFilter.find('li').removeClass('active');
            appnFolderFilter.find('#' + (!value ? 'appnFolderFilter-all' : value)).closest('li').addClass('active');
        }
        folderFilter.setValue = setValue;
        function reset() {
            setValue();
        }
        folderFilter.reset = reset;
        function showDialog($organiseBtn, title) {
            if (appn.ui.isElementDisabled($organiseBtn))
                return;
            folderFilter.selectedItems = $('.selectRow:checked');
            let organiseUrl = appn.urls.folders.organise + '/' + folderFilter.selectedFolderId;
            if (!folderFilter.selectedFolderId)
                organiseUrl += '00000000-0000-0000-0000-000000000000';
            appn.iframe.openModal({ url: organiseUrl, title: title });
        }
        folderFilter.showDialog = showDialog;
        function listContains(value) {
            let exists = false;
            const templates = $('.appnFolderFilter .appnFolderFilter-link');
            $(templates).each(function () {
                if ((this).id === 'appnFolderFilter-all')
                    return true;
                if ((this).id === value) {
                    exists = true;
                    return false;
                }
                return true;
            });
            return exists;
        }
        folderFilter.listContains = listContains;
        function initLinkedFolders() {
            $('.linkedFolders .closeCell').click(function (event) {
                event.preventDefault();
                appn.folderFilter.removeItemFromFolder($(this));
            });
        }
        folderFilter.initLinkedFolders = initLinkedFolders;
        function removeItemFromFolder(htmlElement) {
            const entityId = htmlElement.attr('data-entity-id');
            const folderId = htmlElement.attr('data-folder-id');
            const folderName = htmlElement.attr('data-folder-name');
            const folderType = htmlElement.attr('data-folder-type');
            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: T('Remove From Folder'),
                message: T(`Are you sure you want to delete this Item from the folder '{0}'?`, folderName),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function (result) {
                    if (!result)
                        return;
                    appn.ajax.post({
                        url: appn.urls.folders.removeItem,
                        data: {
                            folderId: folderId,
                            entityId: entityId,
                            folderType: folderType
                        },
                        done: function () {
                            appn.location.reloadCurrentPage();
                        },
                        fail: function () {
                            appn.toast.notify(appn.toast.Type.error, T('Failed to remove object from folder.'));
                        }
                    });
                }
            });
        }
        folderFilter.removeItemFromFolder = removeItemFromFolder;
        let FolderEntity;
        (function (FolderEntity) {
            FolderEntity[FolderEntity["Screen"] = 0] = "Screen";
            FolderEntity[FolderEntity["Doc"] = 1] = "Doc";
            FolderEntity[FolderEntity["DataSource"] = 2] = "DataSource";
            FolderEntity[FolderEntity["Folder"] = 3] = "Folder";
            FolderEntity[FolderEntity["TaskTemplate"] = 4] = "TaskTemplate";
            FolderEntity[FolderEntity["Dashboard"] = 5] = "Dashboard";
            FolderEntity[FolderEntity["Sync"] = 6] = "Sync";
        })(FolderEntity = folderFilter.FolderEntity || (folderFilter.FolderEntity = {}));
    })(folderFilter = appn.folderFilter || (appn.folderFilter = {}));
})(appn || (appn = {}));
